import { useCallback } from "react";

import type { GoogleFreeBookingLinksSettingsUpdateHotelTypeInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { UpdateGoogleFreeBookingLinksSettingsHotelType } from "./mutation";

export const useUpdateGoogleFreeBookingLinksSettingsHotelType = () => {
	const { mutationFunc } = useCustomMutation(UpdateGoogleFreeBookingLinksSettingsHotelType);

	const updateGoogleFreeBookingLinksSettingsHotelType = useCallback(
		async (input: GoogleFreeBookingLinksSettingsUpdateHotelTypeInput) => {
			return await mutationFunc({
				variables: {
					input,
				},
			});
		},
		[mutationFunc],
	);

	return {
		updateGoogleFreeBookingLinksSettingsHotelType,
	};
};
